/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EffectiveDateSelect/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function EffectiveDateSelect({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/Content/Content/PaymentMethods/CreditCardManualPayment/EffectiveDateSelect",
  onChange,
  isInvalid,
  isSubmitting
  
}) {
let paymentsPostPaymentCreditCardManualEffectiveDateValueData = fromData.useDataFormat({ viewPath,
context: 'payments_post_payment',
path: 'credit_card_manual.effective_date',
format: fromFormat.dateISOIn,
})
let paymentsPostPaymentCreditCardManualEffectiveDateIsValidData = fromData.useDataIsValid({ viewPath,
context: 'payments_post_payment',
path: 'credit_card_manual.effective_date',
validate: fromValidate.date,
required: true,
})
let paymentsPostPaymentCreditCardManualEffectiveDateChangeData = fromData.useDataChange({ viewPath,
context: 'payments_post_payment',
path: 'credit_card_manual.effective_date',
formatOut: fromFormat.dateShortOut,
})
let paymentsPostPaymentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payments_post_payment',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 type="date"
 placeholder="mm/dd/yyyy"
 data="payments_post_payment.credit_card_manual.effective_date"
 format="/Data/format.js dateISOIn"
 formatOut="/Data/format.js dateShortOut"
 validate="/Data/validate.js date"
 required={true}
 value={paymentsPostPaymentCreditCardManualEffectiveDateValueData}
 onChange={paymentsPostPaymentCreditCardManualEffectiveDateChangeData}
 invalid={!paymentsPostPaymentCreditCardManualEffectiveDateIsValidData}
 data="payments_post_payment"
 disabled={paymentsPostPaymentIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Effective date"
 weight="medium"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 backgroundColor="white"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="date"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}